import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'

interface TestIds {
  headline: string
  description: string
  clearButton: string
}

interface NoSearchResultsProps {
  testIds?: TestIds
  clearSearchCriteria?: () => void
}
const NoSearchResults = ({ testIds, clearSearchCriteria }: NoSearchResultsProps) => {
  const { t } = useTranslation()

  return (
    <EmptyState
      testId={testIds?.headline ?? 'no-search-results-content'}
      title={t('noSearchResultHeadline')}
      description={
        <span>
          {t('noSearchResultDescription')}{' '}
          <Button
            noPadding
            variant="ghost"
            {...(testIds?.clearButton && { testid: testIds?.clearButton })}
            {...(!!clearSearchCriteria && { onClick: clearSearchCriteria })}
          >
            {t('clearSearchCriteria')}
          </Button>
        </span>
      }
      LottiePlayer={<Lottie src="no-results" />}
    />
  )
}

export default NoSearchResults
